export const ASSESSMENT_ANSWERS_QUERY = '/assessment/answers';
export const NEW_IN_SCOPE_DOMAINS_QUERY = '/quick-answer/new-in-scope-domains';
export const REASSESMENT_STATUS_QUERY = '/reassessment/status';
export const QUICK_ANSWER_CONFIG_QUERY = '/quick-answer/config';
export const QUICK_ANSWER_JOBS_QUERY = '/quick-answer/jobs';
export const QUICK_ANSWER_SUGGESTIONS_QUERY = '/quick-answer/suggestions';
